<template lang="pug">
    div.suggestedSnackbar(:class="{ 'openedSnackbar': open }")
        div
            div.snackbarTitle Today We Recommend
            div.snackbarClose
                button(
                    fab
                    dark
                    small
                    @click="handleClose"
                    color="white"
                )
                    v-icon(color="white") close

            div.sessionCard(v-if="session" @click="navigateToSession")
                div.sessionImage(:style="{ backgroundImage: `url('${session.poster}')` }")
                    div.sessionDuration(v-if="session.duration")
                        div {{ session.duration | timeCode }}

                    div.sessionPlayIcon
                        v-icon.icon play_arrow

                div.sessionContent
                    div.sessionTitle {{ session.title }}
                    div.snackbarSubtitle {{ session.description }}
</template>

<script>
    import VueTypes from 'vue-types';
    import shuffle from 'lodash/shuffle';
    import sessions from '~api/sessions';
    import formattedFullName from '~filters/FormattedFullName';
    import { defineTrackviewOptions, TrackView } from '~services';
    import { mapGetters } from 'vuex';
    import timeCode from '~filters/timeCode';

    export default {
        filters: {
            formattedFullName,
            timeCode
        },
        data() {
            return {
                open: false,
                session: undefined
            };
        },
        props: {
            handleClose: VueTypes.func.def(() => {})
        },
        computed: {
            ...mapGetters('auth', ['user'])
        },
        watch: {
            $route(to) {
                if (to.path.includes('/sessions/view/')) {
                    this.open = false;
                }
            }
        },
        async created() {
            const resp = await sessions.list({ isSuggested: true });
            if (resp.ok) {
                const randomSessions = shuffle(resp.data.items);
                this.session = randomSessions[0];
                setTimeout(() => (this.open = true), 2000);
                setTimeout(() => {
                    if (this.open) this.open = false;
                }, 2 * 60 * 1000);
            }
        },
        methods: {
            navigateToSession() {
                const trackOptions = defineTrackviewOptions(
                    this.user,
                    this.session
                );
                TrackView('click-on-suggested-session', trackOptions);
                this.handleClose();
                this.$router.push({
                    name: 'dashboard.sessions.view',
                    params: { id: this.session.id }
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .sessionPlayIcon
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        transition: opacity 0.3s
        opacity: 0

        .icon
            font-size: 50px
            color: white


    .suggestedSnackbar
        background: linear-gradient(0deg,rgba(112,150,210,.98),rgba(2,35,65,1));
        position: fixed
        padding: 10px 16px 16px 16px
        border-radius: 12px
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35)
        top: -400px
        left: 50%
        margin-left -300px
        width: 600px
        z-index: 20
        transition: top 0.4s, opacity 0.5s;
        opacity: 0

        // position: fixed is relative to the viewport, not #app-shell, so
        // the safe-area padding the shell applies doesn't carry over here.
        // On Android edge-to-edge the viewport top is behind the status
        // bar — pin to the inset PLUS a 12px gap so the rounded card
        // floats below the status bar instead of sitting flush. iOS
        // reports 0 for the inset because overlaysWebView=false.
        &.openedSnackbar
            top: calc(env(safe-area-inset-top, 0px) + 12px)
            opacity: 1

    .snackbarClose
        position: absolute
        right: 10px
        top: 10px
        cursor: pointer

    .sessionDuration
        position: absolute
        left: 8px
        bottom: 8px
        font-size: 12px
        padding: 5px 4px
        border-radius: 10px
        background: linear-gradient(90deg, rgb(#022341) 0%, rgba(#022341, 0.7) 100%);

    .sessionImage
        width: 220px !important
        position: relative
        min-height: 160px
        border-radius: 10px
        overflow: hidden
        background-position: 46% center
        background-size: cover

        &:hover .sessionPlayIcon
            opacity: 1

    .snackbarTitle
        font-weight: 500
        font-size: 24px
        margin-bottom: 10px

    .snackbarSubtitle
        font-style: italic
        font-size: 18px
        margin-bottom: 5px
        max-width: 340px

    .sessionContent
        padding-left: 16px

    .sessionTitle
        font-size: 20px

    .sessionCard
        display: flex
        cursor: pointer
        padding-top: 5px

    .instructorAvatar
        width: 42px
        height: 42px
        border-radius: 42px
        overflow: hidden
        margin-right: 15px

    .sessionInstructor
        display: flex
        align-items: center
        margin-top: 10px
        font-size: 16px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .sessionPlayIcon
            opacity: 1

        .snackbarClose
            position: absolute
            right: 10px
            top: 10px
            cursor: pointer

        .sessionImage
            width: 170px !important
            min-height: 120px

        .snackbarTitle
            font-size: 20px
            margin-bottom: 5px

        .snackbarSubtitle
            font-size: 14px
            max-width: 240px

        .sessionTitle
            font-size: 16px

        .suggestedSnackbar
            // 12px side margins so the rounded card has air on both
            // sides instead of bleeding into the screen edges.
            left: 12px
            right: 12px
            margin-left: 0
            width: auto

        .sessionContent
            padding-left 10px

        .instructorAvatar
            width: 36px
            height: 36px
            border-radius: 36px
</style>
